/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, ReactNode} from 'react'
import {useIntl} from 'react-intl'
import { Spinner } from './Spinner'

interface Props {
  loading: boolean
  nextPage: string | undefined
  nextPageOnClickHandler: () => void
  listComponent: ReactNode
}

const ListContent: FC<Props> = ({
  loading,
  nextPage,
  nextPageOnClickHandler,
  listComponent,
}) => {
  const intl = useIntl()

  return (
    <>
      <div className='col-12'>
        {loading && !nextPage ? (
          <Spinner />
        ) : (
          <>
            <div className='card-scroll h-600px '>{listComponent}</div>
            {nextPage && (
              <div
                className='d-flex flex-column flex-row-fluid btn btn-sm btn-primary mt-2'
                onClick={nextPageOnClickHandler}
              >
                <div className='d-flex flex-row flex-column-fluid'>
                  <div className='d-flex flex-row-fluid flex-center'>
                    <div className='d-flex align-items-center'>
                      {loading ? (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'UTIL.PROCESSING'})}
                          {/* <span className='spinner-border spinner-border-sm align-middle'></span> */}
                        </span>
                      ) : (
                        <>
                          <i className='bi bi-download me-3'></i>
                          <span className='indicator-label'>
                            {intl.formatMessage({id: 'UTIL.LOAD_MORE'})}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  )
}

export {ListContent}
